/*
 * POST /v1/users errors that mean "this email + password can't be used".
 * They get the same copy as a failed login so the UI never confirms whether
 * an account exists (or is banned).
 */
const SIGNUP_CREDENTIALS_ERRORS = ['USER_EMAIL_ALREADY_EXISTS', 'BANNED_USER'];

export const isSignupCredentialsError = (type?: string | null): boolean =>
  !!type && SIGNUP_CREDENTIALS_ERRORS.includes(type);
